import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-full bg-gray-lp p-2 pb-4" }
const _hoisted_2 = { class: "w-full h-full flex flex-col flex-grow overflow-y-auto" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "list-decimal ml-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Summary = _resolveComponent("Summary")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Actions = _resolveComponent("Actions")!
  const _component_CardProgress = _resolveComponent("CardProgress")!
  const _component_CardCollapsible = _resolveComponent("CardCollapsible")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!
  const _component_CopyTemplate = _resolveComponent("CopyTemplate")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Summary, { dataSummary: _ctx.dataSummary }, null, 8, ["dataSummary"]),
        (_ctx.isEmptyList)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 0,
              class: "bg-white h-full rounded-xl",
              icon: "noData_empty",
              customHeaderMessage: _ctx.$t('dashboard.hanging.emptyHeader'),
              customMessage: _ctx.$t('dashboard.hanging.emptyMessage')
            }, null, 8, ["customHeaderMessage", "customMessage"]))
          : (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_Filter, {
                class: "mb-2",
                onFilter: _ctx.getFilter
              }, null, 8, ["onFilter"]),
              _createVNode(_component_Actions, {
                class: "mb-2",
                isConsoleBkd: true,
                data: _ctx.hangingBkdConsoleList,
                onUpdate: _ctx.updateStatus,
                onDownload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadHangingBkdConsole([])))
              }, null, 8, ["data", "onUpdate"]),
              _createVNode(_component_CardProgress, {
                "total-completed": _ctx.dataSummary.doneActivities,
                "total-activities": _ctx.dataSummary.totalActivities,
                "total-pending": _ctx.dataSummary.pendingActivities,
                "is-loading": _ctx.isLoadingFetch
              }, null, 8, ["total-completed", "total-activities", "total-pending", "is-loading"]),
              (_ctx.hangingBkdConsoleList.length || _ctx.isLoadingList)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode(_component_CardCollapsible, {
                      loading: _ctx.isLoadingList,
                      modelValue: _ctx.hangingBkdConsoleList,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.hangingBkdConsoleList = $event)),
                      isCheckbox: true,
                      onConfirm: _ctx.onConfirmDone,
                      onTemplate: _ctx.onClickTemplateMessage,
                      onDownload: _ctx.downloadHangingBkdConsole
                    }, null, 8, ["loading", "modelValue", "onConfirm", "onTemplate", "onDownload"])
                  ]))
                : (_openBlock(), _createBlock(_component_EmptyState, {
                    key: 1,
                    class: "mt-2 h-full",
                    icon: "ill_spot_search",
                    customHeaderMessage: _ctx.$t('dashboard.hanging.searchEmptyHeader'),
                    customMessage: _ctx.$t('dashboard.hanging.searchEmptyMessage')
                  }, null, 8, ["customHeaderMessage", "customMessage"]))
            ]))
      ])
    ]),
    _createVNode(_component_ConfirmAction, {
      modelValue: _ctx.openConfirmUpdateStatus,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openConfirmUpdateStatus = $event)),
      title: _ctx.$t('dashboard.hanging.confirmTitle'),
      textSuccess: _ctx.$t('dashboard.hanging.confirmSuccess'),
      messageHtml: _ctx.messageHtml,
      onConfirm: _ctx.onUpdateStatus
    }, null, 8, ["modelValue", "title", "textSuccess", "messageHtml", "onConfirm"]),
    _createVNode(_component_CopyTemplate, {
      modelValue: _ctx.isOpenTemplate,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenTemplate = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("p", null, _toDisplayString(_ctx.$t('dashboard.hanging.templateIntro')) + " " + _toDisplayString(_ctx.accountTypeMsg) + " " + _toDisplayString(_ctx.$t('dashboard.hanging.templateLionParcel')) + " " + _toDisplayString(_ctx.accountData.account_type_detail.partnerLocation?.city?.code) + ". ", 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('dashboard.hanging.templateHanging')) + " (" + _toDisplayString(_ctx.selectedCard.groupName) + ") " + _toDisplayString(_ctx.$t('dashboard.hanging.templateMoreThan3Days')) + ". ", 1),
        _createVNode("p", null, _toDisplayString(_ctx.$t('dashboard.hanging.templateTotal', { count: _ctx.selectedCard.stt.length })), 1),
        _createVNode("ol", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedCard.stt, (item, index) => {
            return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _createVNode("p", null, _toDisplayString(_ctx.$t('dashboard.hanging.templateHelpQuestion')) + " " + _toDisplayString(_ctx.$t('dashboard.hanging.templateThanks')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}